<template>
  <div>
    <v-btn
      @click.stop="addToWatchlist"
      flat
      icon
      :class="{ 'btn-watchlist': true, 'btn-active': active, 'btn-inactive': !active }"
    >
      <v-icon v-if="active">visibility</v-icon>
      <v-icon v-else>visibility_off</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'WatchlistButton',

  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    addToWatchlist() {
      console.log('add to watchlist clicked');
      this.$emit('add-to-watchlist');
    },
  },
};
</script>

<style scoped></style>
